import { z } from "zod";
import { adminCountSchema, adminEngineSchema, adminMicrosSchema } from "./common.js";
/**
 * A vendor's account, as the vendor reported it while the page loaded. Each
 * kind is its own reading: no key is not an empty balance, and an account the
 * vendor did not answer for is not zero credits.
 */
export const adminVendorAccountSchema = z.discriminatedUnion("kind", [
    z.object({
        kind: z.literal("balance"),
        usdMicros: adminMicrosSchema,
        /** Everything ever paid in. */
        paidInUsdMicros: adminMicrosSchema,
    }),
    z.object({
        kind: z.literal("credits"),
        remaining: adminCountSchema,
        /** The plan's monthly credits; null on a plan without them. */
        perCycle: adminCountSchema.nullable(),
        resetsAt: z.string().nullable(),
    }),
    z.object({ kind: z.literal("not_set") }),
    z.object({ kind: z.literal("not_read"), reason: z.string() }),
    z.object({ kind: z.literal("no_endpoint") }),
]);
export const adminVendorIdSchema = z.enum(["dataforseo", "oxylabs", "cloro"]);
/**
 * Where each engine's answers come from, the plan Crux is on with its vendor,
 * and what this month asked, answered and cost (`server/.../admin/engines.rs`).
 * Every engine Crux can ask is listed, asked here or not.
 */
export const adminEnginesSchema = z.object({
    /** `YYYY-MM`, in the capture timezone. */
    month: z.string().regex(/^\d{4}-\d{2}$/u),
    vendors: z.array(z.object({
        id: adminVendorIdSchema,
        label: z.string(),
        plan: z.string(),
        account: adminVendorAccountSchema,
    })),
    engines: z.array(z.object({
        engine: adminEngineSchema,
        /** Whether this server asks it (`CAPTURE_ENGINES`). */
        asked: z.boolean(),
        vendor: adminVendorIdSchema,
        product: z.string(),
        how: z.string(),
        plan: z.string(),
        price: z.string(),
        month: z.object({
            asked: adminCountSchema,
            answered: adminCountSchema,
            noAnswer: adminCountSchema,
            failed: adminCountSchema,
            pending: adminCountSchema,
            usdMicros: adminMicrosSchema,
        }),
    })),
});
//# sourceMappingURL=engines.js.map